import { ThunkDispatch } from "core-integration/src/store";
import { banLeagueEntry } from "core-integration/src/store/leagues/thunks";
import { IPrivateLeagueAdmin } from "core-integration/src/store/leagues/types";
import { Button } from "plos/src/components/buttons/Button";
import { useLocalizedNavigate } from "plos/src/hooks/useLocalizedNavigate";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { formItem } from "../../../LeaguesAndCups/leaguesAndCups.css";
import { EntrySelector } from "../EntrySelector";
import { formWrapper, headingStyles } from "./addBan.css";

interface OwnProps {
  league: IPrivateLeagueAdmin;
}

const AddBan = ({ league }: OwnProps) => {
  const { t } = useTranslation("leaguesAndCups");
  const [entry, setEntry] = useState<number>(0);
  const dispatch = useDispatch<ThunkDispatch>();
  const navigate = useLocalizedNavigate();

  const handleEntryChange = (entryId: number) => {
    setEntry(entryId);
  };

  const handleSubmit = async (e: React.SyntheticEvent<HTMLFormElement>) => {
    e.preventDefault();
    await dispatch(banLeagueEntry(league.id, { entry }));
    navigate("/leagues");
  };

  const disabled = !entry;

  return (
    <div className={formItem}>
      <form onSubmit={handleSubmit} className={formWrapper}>
        <h3 className={headingStyles}>
          {t("addLeagueSuspensions", "Add League suspensions")}
        </h3>
        <p>
          {t(
            "suspendPlayerInstructions",
            "Search for the player you wish to suspend from this league. Once the player has been suspended they will be unable to rejoin the league again.",
          )}
        </p>
        <EntrySelector
          handleChange={handleEntryChange}
          leagueId={league.id}
          excluded={[league.admin_entry]}
        />
        <div>
          <Button type="submit" isDisabled={disabled}>
            {t("suspendPlayer", "Suspend Player")}
          </Button>
        </div>
      </form>
    </div>
  );
};

export default AddBan;
